import Cookies from 'js-cookie'

export const CookieSetting = {
  token: 'hai_nan_le_cheng_mobile_token',
  openId: 'hai_nan_le_cheng_mobile_openId',
  userId: 'hai_nan_le_cheng_mobile_userId',
  headImg: 'hai_nan_le_cheng_mobile_headImg',
  nickName: 'hai_nan_le_cheng_mobile_nickname',
  userName: 'hai_nan_le_cheng_mobile_userName',
  mobilePhone: 'hai_nan_le_cheng_mobile_mobile_phone',
  isSubscribe: 'hai_nan_le_cheng_mobile_is_subscribe',
  expires: process.env.NODE_ENV === 'development' ? 60 : 0.05 // cookie存留时间60天， 1个小时应为 60/1440 提交到测试时，保留0.1天
}
/**
 * 绑定、获取token时要带的参数
 * 公众号id
 * */
export const AppCode = process.env.VUE_APP_BUILD_TARGET === 'prod' ? 'wxf9fcf1a607686642' : 'wxe47aee2b50062827'
// export const AppCode = 'wxa8bd3198738586b3'
  // 新  wxf9fcf1a607686642
  // 旧 wx8a1ec86fe697fee4
/**
 * 用户信息 cookie 操作
 * */
export const SetGetAuthInfo = {
  setInfo(obj = {}) {
    if (obj.token) {
      Cookies.set(CookieSetting.token, obj.token, {
        expires: CookieSetting.expires
      })
    }
    if (obj.openId) {
      Cookies.set(CookieSetting.openId, obj.openId, {
        expires: CookieSetting.expires
      })
    }
    if (obj.userId) {
      Cookies.set(CookieSetting.userId, obj.userId, {
        expires: CookieSetting.expires
      })
    }
    if (obj.headImg) {
      Cookies.set(CookieSetting.headImg, obj.headImg, {
        expires: CookieSetting.expires
      })
    }
    if (obj.userAlias) {
      Cookies.set(CookieSetting.nickName, obj.userAlias, {
        expires: CookieSetting.expires
      })
    }
    if (obj.userName) {
      Cookies.set(CookieSetting.userName, obj.userName, {
        expires: CookieSetting.expires
      })
    }
    if (obj.mobilePhone) {
      Cookies.set(CookieSetting.mobilePhone, obj.mobilePhone, {
        expires: CookieSetting.expires
      })
    }
    if (obj.isSubscribe) {
      Cookies.set(CookieSetting.isSubscribe, obj.isSubscribe, {
        expires: CookieSetting.expires
      })
    }
  },
  getInfo() {
    return {
      token: Cookies.get(CookieSetting.token) || '', // eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZGVudGlmaWVyIjoiNjA5ZGE2YzVlMjI1ZWMyNmU4MTcwZTAzYWU5N2QwMzEiLCIyMjQ0NDIxMDgxMjgyNDk1NSI6IjIyNDQ0MjEwODEyODI0OTU1IiwiZXhwaXJlIjo2MDQ4MDB9.9ecjx3qykTJFtwMMwjTR-PZS2OIHJ0Lv4KrTzp3kQb0
      openId: Cookies.get(CookieSetting.openId) || '', // oss_9wCQJY9D7-bOc7YuNGWRqLbE
      userId: Cookies.get(CookieSetting.userId) || '', // 609da6c5e225ec26e8170e03ae97d031
      headImg: Cookies.get(CookieSetting.headImg) || '',
      nickName: Cookies.get(CookieSetting.nickName) || '',
      userName: Cookies.get(CookieSetting.userName) || '',
      mobilePhone: Cookies.get(CookieSetting.mobilePhone) || '15020910730', // 15020910730
      isSubscribe: Cookies.get(CookieSetting.isSubscribe) || ''
    }
  },
  removeInfo() {
    Cookies.remove(CookieSetting.token)
    Cookies.remove(CookieSetting.openId)
    Cookies.remove(CookieSetting.userId)
    Cookies.remove(CookieSetting.headImg)
    Cookies.remove(CookieSetting.nickName)
    Cookies.remove(CookieSetting.userName)
    Cookies.remove(CookieSetting.mobilePhone)
    Cookies.remove(CookieSetting.isSubscribe)
  }
}

/**
 * 是否进行过授权判断
 * */
export const HasAuthed = {
  key: 'haiNanLeChengAuthed',
  yes: 'yes'
}
